import { LegacyLinesDiffComputer } from './legacyLinesDiffComputer.js';
import { DefaultLinesDiffComputer } from './defaultLinesDiffComputer/defaultLinesDiffComputer.js';
const linesDiffComputers = {
    getLegacy: () => ( new LegacyLinesDiffComputer()),
    getDefault: () => ( new DefaultLinesDiffComputer()),
};
export { linesDiffComputers };
